import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { InformationAlertBanner, InformationBannerType } from 'reactApp/ui/InformationAlertBanner/InformationAlertBanner';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FreemiumEndedBanner.css';

const TARIFF_ID_WITH_DISCOUNT = 'W256GB_1m_family_features_discount_3m';

const getAnalyticsName = (): string => {
    if (isHardFreemium) {
        return 'mnz_sub_ended_unlimited_hard_freemium';
    }
    if (isSoftFreemium) {
        return 'mnz_sub_ended_unlimited_soft_freemium';
    }
    return 'mnz_sub_ended_unlimited_soft_freemium';
};

const getPaySource = (): string => {
    if (isHardFreemium) {
        return 'mnz_family_unlimited_hard_freemium_banner_sub_ended';
    }
    if (isSoftFreemium) {
        return 'mnz_family_unlimited_soft_freemium_banner_sub_ended';
    }
    return 'mnz_family_unlimited_soft_freemium_banner_sub_ended';
};

export const FreemiumEndedBanner = memo(() => {
    const dispatch = useDispatch();
    const analyticsName = getAnalyticsName();
    const paySource = getPaySource();

    useEffect(() => {
        sendDwh({
            eventCategory: 'banner',
            action: 'show',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });
    }, [analyticsName]);

    const handlePrimaryClick = useCallback(() => {
        sendDwh({
            eventCategory: 'banner',
            action: 'click',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });
        productsController.loadProducts().then(() => {
            dispatch(
                openTariffBuy({
                    productId: TARIFF_ID_WITH_DISCOUNT,
                    paySource,
                    title: 'Семейный тариф Mail Space',
                })
            );
        });
    }, [dispatch, analyticsName, paySource]);

    return (
        <div className={styles.wrapper}>
            <InformationAlertBanner
                title="Пробный период подписки закончился"
                content={
                    <div className={styles.content}>
                        Подключите её со скидкой — вернётся безлимит для фото с телефона, и снова отключится реклама
                    </div>
                }
                primaryButtonTitle="Подключить со скидкой"
                type={InformationBannerType.info}
                onPrimaryClick={handlePrimaryClick}
                closable={false}
            />
        </div>
    );
});

FreemiumEndedBanner.displayName = 'FreemiumEndedBanner';
